import {useShallowEqualSelector} from "../index";

/**
 * Returns the todos data
 */
export const useStatsSelector = () => {
    return useShallowEqualSelector(({ stats }) => {
        return stats;
    });
};